// src/hooks/useActionLock.js
import { useCallback, useRef, useState } from 'react';

export function useActionLock() {
    const lockRef = useRef(false);
    const [isLocked, setIsLocked] = useState(false);

    const run = useCallback(async (fn) => {
        if (lockRef.current) return { blocked: true };

        lockRef.current = true;
        setIsLocked(true);

        try {
            return await fn();
        } finally {
            lockRef.current = false;
            setIsLocked(false);
        }
    }, []);

    return {
        isLocked,
        run,
        lockRef, // opcional, se quiser compat
    };
}
